// GERADO AUTOMATICAMENTE por scripts/sync-version.js.
// Nao editar manualmente — atualize "version" em package.json e este
// arquivo eh regerado no proximo npm start / npm run build.
export const VERSION = '1.7.7';
